import { useTranslation } from 'react-i18next';
import styles from './InfoWrapper.module.css';
import { ReactNode } from 'react';
import classNames from 'classnames';

interface Props {
  children: ReactNode;
  className?: string;
  onClose?: () => void;
  closeButtonText?: string;
  closeButtonIconClass?: string;
  buttonColor?: 'green' | undefined;
}

export const InfoWrapper = ({
  children,
  onClose = () => {},
  className = undefined,
  closeButtonText = undefined,
  closeButtonIconClass = undefined,
  buttonColor = undefined,
}: Props) => {
  const { t } = useTranslation();
  return (
    <div className={classNames(styles.wrapper, className)}>
      <div>Info</div>
      {children}
      <div className={styles.buttonWrapper}>
        <div onClick={onClose} data-button-color={buttonColor}>
          {closeButtonText ?? t('close_label')}
          <div className={closeButtonIconClass ?? styles.xmark} />
        </div>
      </div>
    </div>
  );
};
